import { Stack } from "@mui/material";
import { Text } from "@src/appV2/redesign/system/ui-components";
import { useHistory } from "react-router-dom";

import { Button } from "../../components/Button";
import { TextButton } from "../../components/TextButton";
import { ShiftCardWrapper } from "../../Shift/Card/Wrapper";
import { useInHomeCaseHistoryDataContext } from "../../ShiftDiscovery/useInHomeCaseHistoryDataContext";
import { VisitCardContentWrapper } from "../Card/ContentWrapper";
import { VisitPayInfoLabel } from "../Card/PayInfoLabel";
import { readableVisitTypeMapping, VisitTypes } from "../constants";
import { BOOKED_VISIT_DETAILS_PATH, IN_HOME_CASE_DETAILS_VISIT_OCCURRENCES_PATH } from "../paths";
import { type VisitWithCaseData } from "../types";
import { getVisitWeeklyFrequencyAndDurationLabel } from "../utils";

interface CaseHistoryVisitCardProps {
  visit: VisitWithCaseData;
}

export function CaseHistoryVisitCard(props: CaseHistoryVisitCardProps) {
  const { visit } = props;
  const history = useHistory();
  const { generateModalPath } = useInHomeCaseHistoryDataContext();

  return (
    <ShiftCardWrapper sx={{ width: "100%", minHeight: "auto" }}>
      <VisitCardContentWrapper>
        <Stack direction="row" spacing={5} justifyContent="space-between">
          <Text semibold variant="body1">
            {visit.attributes.workerReq}
          </Text>
          <TextButton
            onClick={() => {
              history.push(
                generateModalPath(IN_HOME_CASE_DETAILS_VISIT_OCCURRENCES_PATH, {
                  caseId: visit.attributes.caseId,
                  visitId: visit.id,
                })
              );
            }}
          >
            Visit History
          </TextButton>
        </Stack>

        <Stack direction="row" spacing={5} justifyContent="space-between">
          <Stack spacing={7}>
            <Stack spacing={1}>
              <Text semibold variant="h6">
                {readableVisitTypeMapping[visit.attributes.type]}
              </Text>
              <VisitPayInfoLabel visit={visit} showTotalPay={false} />
              {visit.attributes.type === VisitTypes.REGULAR && (
                <Text semibold variant="body1">
                  {getVisitWeeklyFrequencyAndDurationLabel(visit)}
                </Text>
              )}
            </Stack>
          </Stack>
          <Button
            onClick={() => {
              history.push(
                generateModalPath(BOOKED_VISIT_DETAILS_PATH, {
                  caseId: visit.attributes.caseId,
                  visitId: visit.id,
                })
              );
            }}
          >
            Log
          </Button>
        </Stack>
      </VisitCardContentWrapper>
    </ShiftCardWrapper>
  );
}
